import globals from "imports/globals";
import $ from "cash-dom";
import { ScrollTween2 as ScrollTween } from "Utilities";

const component = (function () {
    $(document).ready(function () {
        if ($(".hero").length) {
            if (globals.debug) console.log("component-hero initialized");
            var factorBack = globals.screenOrientation == "portrait" ? 0.375 : 0.5;
            var factorFront = globals.screenOrientation == "portrait" ? 0.125 : 0.25;
            $(window).on("preloaderHidden", function () {
                $(".hero-typography, .hero-card-layer").removeClass("hidden").addClass("on");
                new ScrollTween({
                    element: $(".hero")[0],
                    from: "top-top",
                    to: "bottom-top",
                    callback: function (_n, _el) {
                        var valBack = factorBack * window.innerHeight * _n;
                        var valFront = factorFront * window.innerHeight * _n;
                        $(_el).find(".hero-back img")[0].style.transform = `translate3d(0, ${valBack}px, 0)`;
                        $(_el).find(".hero-front img")[0].style.transform = `translate3d(0, ${valFront}px, 0)`;
                    },
                });
            });

            $(window).on("resize", function () {
                factorBack = globals.screenOrientation == "portrait" ? 0.375 : 0.5;
                factorFront = globals.screenOrientation == "portrait" ? 0.125 : 0.25;
            });
        }
    });
})();

export default component;
